import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state type and export it
export interface UiState {
  sidebarOpen: boolean;
}

const initialState: UiState = {
  sidebarOpen: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: state => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarOpen } = uiSlice.actions;

export default uiSlice.reducer;
